import React, { useMemo } from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { compareStrings, nullSafeGet } from '../../utils/DataAccessUtils';
import DateTimeHover from '../date_time_component/DateTime';
import { RFP_STATUS } from '../../constants/BidderStatuses';
import { connect } from 'react-redux';
import { UserName } from '../name_component/user/UserNameComponent';
import {
	isDatePastDue,
	requestForProposalStatusIndicatorFormatter,
} from '../../utils/DataFormatterUtils';
import PastDue from '../work_order_row_display_simple/PastDue';

require('./RFPRowDisplay.less');

const RFPRowDisplay: React.FC<any> = ({ rfp, currentUser, ...props }) => {
	const actionName = useMemo(() => {
		switch (rfp.status) {
			case RFP_STATUS.ACTIVE:
				return 'Published';
			case RFP_STATUS.CLOSED:
				return 'Closed';
			case RFP_STATUS.AWARD:
				return 'Awarded';
			default:
				return '';
		}
	}, [rfp.status]);

	const rfpStatusDetail = useMemo(
		() =>
			nullSafeGet('publishedOrClosedOrAwardedByContact', rfp) ||
			nullSafeGet('publishedOrClosedOrAwardedAt', rfp) ? (
				<>
					<span>
						{`${actionName}`}
						<>
							{nullSafeGet('publishedOrClosedOrAwardedByContact', rfp) ? (
								<span>
									{' by '}
									<UserName
										contact={rfp.publishedOrClosedOrAwardedByContact}
										mode={'inline'}
										placement={'top'}
									/>
								</span>
							) : (
								''
							)}
						</>
					</span>
					<>
						{nullSafeGet('publishedOrClosedOrAwardedAt', rfp) ? (
							<span>
								{' '}
								<DateTimeHover
									timeZone={nullSafeGet('workorder.location.timeZoneId', rfp)}
									timestamp={rfp.publishedOrClosedOrAwardedAt}
								/>
							</span>
						) : null}
					</>
				</>
			) : null,
		[actionName, rfp]
	);

	return (
		<div className="rfpRowDisplay" {...props}>
			<div>
				<div className="rfpRowDisplay__rowTitle">
					<Ellipsis tooltip={true} length={64}>
						{rfp.title}
					</Ellipsis>
				</div>
				<div className="rfpRowDisplay__rowSubtitle">
					{nullSafeGet('workOrder.location.name', rfp) ? (
						<div className="rfpRowDisplay__rowInlineGroup">
							<span className="rowGrayChip">
								<i className="icons8-font icons8-location-marker" />
								<span>{nullSafeGet('workOrder.location.name', rfp)}</span>
							</span>
						</div>
					) : null}
					<div className="rfpRowDisplay__rowInlineGroup">
						{requestForProposalStatusIndicatorFormatter(rfp.status)}
					</div>
					{nullSafeGet('workOrder.problemType.hierarchyName', rfp) ? (
						<div className="rfpRowDisplay__rowInlineGroup">
							<i className="icons8-font icons8-maintenance-filled" />
							{nullSafeGet('workOrder.problemType.hierarchyName', rfp)}
						</div>
					) : null}
					<div className="rfpRowDisplay__rowInlineGroup py-2">
						<span>WO #{nullSafeGet('workOrder.id', rfp)}</span>
					</div>
				</div>
				<div className="rfpRowDisplay__rowSubtitle mt-2">
					{!compareStrings(nullSafeGet('status', rfp), RFP_STATUS.AWARD) ? (
						isDatePastDue(nullSafeGet('dueDate', rfp)) ? (
							<PastDue
								className="mr-4"
								dueDate={nullSafeGet('dueDate', rfp)}
								showTime={false}
								showYear={false}
							/>
						) : (
							<span className="mr-4">
								Due{' '}
								<DateTimeHover
									timestamp={nullSafeGet('dueDate', rfp)}
									showTime={false}
									showYear={false}
								/>
							</span>
						)
					) : null}
					{compareStrings(nullSafeGet('status', rfp), RFP_STATUS.DRAFT) && (
						<span>
							Created{' '}
							<DateTimeHover
								timeZone={nullSafeGet('workorder.location.timeZoneId', rfp)}
								timestamp={rfp.createdAt}
							/>
						</span>
					)}
					{rfpStatusDetail}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(RFPRowDisplay);
